import { ReactNode } from 'react';
import { Text } from '@pairy/pds-react';

import * as Styled from './index.styles';

interface Props {
  onOpenChange: (isOpen: boolean) => void;
  /** 플랜 카드 · 쿠폰 · 결제 버튼 */
  plans: ReactNode;
  /** 플랜별 기능 비교표 */
  comparison: ReactNode;
}

/** 우측 슬라이드 패널(플랜 선택) + 좌측 비교표 2단 구성. */
const ModalShell = ({ onOpenChange, plans, comparison }: Props) => {
  return (
    <>
      <Styled.Overlay />
      <Styled.SplitPanel direction="column" padding={{ bottom: 40 }}>
        <Styled.FlexHeader justifyContent="space-between" alignItems="center">
          <Text variant="lg-semibold">플랜 선택</Text>
          <Text
            variant="md-medium"
            as="button"
            onClick={() => {
              onOpenChange(false);
            }}
            color="zinc_400"
          >
            닫기
          </Text>
        </Styled.FlexHeader>
        {plans}
      </Styled.SplitPanel>
      <Styled.SplitComparisonArea>{comparison}</Styled.SplitComparisonArea>
    </>
  );
};

export default ModalShell;
